"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.ImageRenderer = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var MediaLoader_1 = require("./MediaLoader");

var RendererConfig_1 = require("./RendererConfig");

exports.ImageRenderer = react_1.forwardRef(function (requestProps, ref) {
  var _a, _b;

  var getStyles = requestProps.getStyles,
      theme = requestProps.theme,
      request = requestProps.request;

  var _MediaLoader_1$useMed = MediaLoader_1.useMediaObjectProps(_objectSpread({
    uri: ((_a = request.media.content) === null || _a === void 0 ? void 0 : _a.uri) || ((_b = request.media.image) === null || _b === void 0 ? void 0 : _b.uri),
    preferredIPFSGateway: theme.preferredIPFSGateway
  }, requestProps)),
      props = _MediaLoader_1$useMed.props,
      loading = _MediaLoader_1$useMed.loading,
      error = _MediaLoader_1$useMed.error;

  return jsx_runtime_1.jsx(MediaLoader_1.MediaLoader, Object.assign({
    getStyles: getStyles,
    loading: loading,
    error: error
  }, {
    children: jsx_runtime_1.jsx("img", Object.assign({
      ref: ref
    }, props), void 0)
  }), void 0);
});
exports.Image = {
  getRenderingPreference: function getRenderingPreference(request) {
    var _a, _b;

    if (request.media.image) {
      // Make low priority only if full screen, move to normal priority if preview
      if (request.renderingContext === "FULL" && request.media.animation) {
        return RendererConfig_1.RenderingPreference.LOW;
      }

      return RendererConfig_1.RenderingPreference.NORMAL;
    }

    if ((_b = (_a = request.media.content) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.startsWith("image/")) {
      return RendererConfig_1.RenderingPreference.NORMAL;
    }

    return RendererConfig_1.RenderingPreference.INVALID;
  },
  render: exports.ImageRenderer
};